import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Description } from './components/Description';
import { Author } from './components/Author';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Kontakt from './pages/Kontakt';
import { useTabTitle } from './hooks/useTabTitle';

function HomePage() {
  return (
    <>
      <Hero />
      <Problem />
      <Solution />
      <Description />
      <Author />
      <FinalCTA />
    </>
  );
}

function App() {
  useTabTitle();

  return (
    <HashRouter>
      <div className="min-h-screen bg-white selection:bg-gold selection:text-navy overflow-x-hidden">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
        <Footer />
        <StickyMobileCTA />
      </div>
    </HashRouter>
  );
}

export default App;